import ProjFloor from './proj-floor'

export default ProjFloor